import { render, staticRenderFns } from "./BaseInputRadio.vue?vue&type=template&id=0dd1a5bd&scoped=true&"
import script from "./BaseInputRadio.vue?vue&type=script&lang=js&"
export * from "./BaseInputRadio.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputRadio.vue?vue&type=style&index=0&id=0dd1a5bd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1a5bd",
  null
  
)

export default component.exports